import {
  CourseDoesNotExistError,
  CourseForbiddenError,
  SectionDoesNotExistError,
  SubscriptionNotActiveError,
  SubscriptionNotFoundError,
  SubscriptionNotValidError
  // @ts-ignore
} from "@seneca/course-service-client";

import getMessageFromError from "seneca-common/utils/functions/services/getMessageFromError";

export const COURSE_DOES_NOT_EXIST_ERROR = "Course does not exist";
export const SECTION_DOES_NOT_EXIST_ERROR = "Section does not exist";
export const NO_SUBSCRIPTION_FOR_COURSE_ERROR = "You don't have a subscription";
export const EXPIRED_SUBSCRIPTION_FOR_COURSE_ERROR =
  "Your subscription has expired";
export const INVALID_SUBSCRIPTION_FOR_COURSE_ERROR =
  "Your subscription is invalid";

export default function errorTranslator(error: Error): string {
  try {
    if (typeof error === "string") return error;

    if (
      error instanceof CourseDoesNotExistError || // for non Seneca users accessing Seneca course
      error instanceof CourseForbiddenError
    ) {
      return COURSE_DOES_NOT_EXIST_ERROR;
    }

    if (error instanceof SectionDoesNotExistError) {
      return SECTION_DOES_NOT_EXIST_ERROR;
    }

    if (error instanceof SubscriptionNotFoundError)
      return NO_SUBSCRIPTION_FOR_COURSE_ERROR;
    if (error instanceof SubscriptionNotActiveError)
      return EXPIRED_SUBSCRIPTION_FOR_COURSE_ERROR;
    if (error instanceof SubscriptionNotValidError)
      return INVALID_SUBSCRIPTION_FOR_COURSE_ERROR;

    return getMessageFromError(error) || "An unknown error has occurred.";
  } catch (err: any) {
    return "An unknown error has occurred.";
  }
}
